import { render } from "./TVList.vue?vue&type=template&id=a9b43146&ts=true"
import script from "./TVList.vue?vue&type=script&lang=ts"
export * from "./TVList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__